import sharedConfig from 'app/shared/sharedConfig';

export const INSTANT_APP_ENABLED = 'INSTANT_APP_ENABLED';
export const ZG_APPLICATIONS_VIEWABLE_GROUP = 'ZG_APPLICATIONS_VIEWABLE_GROUP';
export const DEV_BRAND = 'dev_brand';
export const HOST_APP = 'hostApp';
export const ZG_API = 'ZG_API';
export const ZG_RENT_GUARANTEE_ENABLED = 'ZG_RENT_GUARANTEE_ENABLED';
export const ZG_ACH_PAYMENTS_ENABLED = 'ZG_ACH_PAYMENTS_ENABLED';
export const ZG_FEED_CONNECT_CREATE_LISTING = 'ZG_FEED_CONNECT_CREATE_LISTING';
export const ZG_FEED_CONNECT_SWITCH_SOURCE = 'ZG_FEED_CONNECT_SWITCH_SOURCE';
export const ZG_FLAT_FEE_ENABLED = 'ZG_FLAT_FEE_ENABLED';
export const SEPARATE_LEASE_CONNECT = 'SEPARATE_LEASE_CONNECT';
export const ZG_ANALYTICS_RENT_COMPS_PAGE = 'ZG_ANALYTICS_RENT_COMPS_PAGE';

export const ZG_MOCK_USER_ENABLED = 'ZG_MOCK_USER_ENABLED';
export const ZG_MOCK_USER_TOKEN = 'ZG_MOCK_USER_TOKEN';
export const ZG_MOCK_USER_EMAIL = 'ZG_MOCK_USER_EMAIL';
export const ZG_MOCK_USER_IMPERSONATOR_TOKEN = 'ZG_MOCK_USER_IMPERSONATOR_TOKEN';
export const ZG_MOCK_USER_IMPERSONATOR_EMAIL = 'ZG_MOCK_USER_IMPERSONATOR_EMAIL';

const FeatureFlagConstants = {
    // features
    [INSTANT_APP_ENABLED]: false,
    [ZG_ACH_PAYMENTS_ENABLED]: false,
    [SEPARATE_LEASE_CONNECT]: false,
    [ZG_FEED_CONNECT_CREATE_LISTING]: false,
    [ZG_FEED_CONNECT_SWITCH_SOURCE]: false,
    [ZG_FLAT_FEE_ENABLED]: false,
    [ZG_RENT_GUARANTEE_ENABLED]: false,
    [ZG_ANALYTICS_RENT_COMPS_PAGE]: false,

    // mocked user is only auto enabled for the sherman environment
    [ZG_MOCK_USER_ENABLED]: false,
    [ZG_MOCK_USER_TOKEN]: '',
    [ZG_MOCK_USER_EMAIL]: '',
    [ZG_MOCK_USER_IMPERSONATOR_TOKEN]: '',
    [ZG_MOCK_USER_IMPERSONATOR_EMAIL]: '',

    // TODO: move those non-boolean values out since they're not
    // strictly features.
    [HOST_APP]: 'none',
    [ZG_APPLICATIONS_VIEWABLE_GROUP]: 'none',
    [DEV_BRAND]: sharedConfig.defaultBrand,
    [ZG_API]: sharedConfig.defaultZgApi,
};

export default FeatureFlagConstants;
